import { useMutation } from '@tanstack/react-query';
import React, { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import message from '~/utils/message';
import Wrapper from '~/App/components/Wrapper';
import Header from '~/App/components/Header';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import Loading from '~/App/components/Loading';
import UserRoleForm from '../../components/UserRoleForm';

const CreateUserRole = () => {
  const navigate = useNavigate();
  const { isPending, mutate } = useMutation({
    mutationFn: api.createUserRole,
    retry: false,
    onSuccess: () => {
      message.success('Success create user role settings');
      navigate('..');
    },
    onError: () => {
      message.error('Fail to create user role settings');
    },
  });

  return (
    <Wrapper>
      <Header title="Create User Role Settings" />
      <ErrorBoundary>
        <Suspense fallback={<Loading className="h-[400px]" />}>
          <UserRoleForm loading={isPending} onSubmit={mutate} />
        </Suspense>
      </ErrorBoundary>
    </Wrapper>
  );
};

export default CreateUserRole;
